import { Injectable } from '@angular/core';

import { LOCAL_STORAGE_KEYS_WEB } from '@eai-tdv/core/models';

import { AppThemeService } from '@eai-tdv/shared/theme-switcher';

import {
  AppVersionService,
  AuthUserFacadeService,
  LocalStorageWebService,
  PwaInstallAppService,
  ROUTES_WITH_DATA,
} from './core/services';

@Injectable()
export class AppInitializerService {
  constructor(
    private appVersionS: AppVersionService,
    private localStorageS: LocalStorageWebService,
    private authUserFacadeS: AuthUserFacadeService,
    private pwaInstallAppS: PwaInstallAppService,
    private themeS: AppThemeService,
  ) {}

  public init(): Promise<boolean> {
    return new Promise<boolean>(resolve => {
      this.themeS.init();
      this.appVersionS.checkVersionAndClearDataIfVersionChanged();
      this.initAuthUserFromLocalStorage();
      this.initPwaInstallation();
      resolve(true);
    });
  }

  private initPwaInstallation(): void {
    this.pwaInstallAppS.init();
  }

  private initAuthUserFromLocalStorage(): void {
    const cached = this.localStorageS.getAuthUser();
    if (cached) {
      this.authUserFacadeS.setAuthProfile(cached);
      this.authUserFacadeS.fetchAuthProfile().subscribe();
    } else {
      this.authUserFacadeS.setAuthProfile(null);
      // set url before login
      this.initRedirectionAfterSuccessLogin();
    }
  }

  private initRedirectionAfterSuccessLogin(): void {
    this.localStorageS.remove(LOCAL_STORAGE_KEYS_WEB.HREF_BEFORE_LOGIN);
    const isRouteWithData = ROUTES_WITH_DATA.find(routeName =>
      window.location.pathname.startsWith('/' + routeName),
    );
    if (isRouteWithData) {
      const fullUrl = window.location.href;
      this.localStorageS.set(LOCAL_STORAGE_KEYS_WEB.HREF_BEFORE_LOGIN, fullUrl);
    }
  }
}

export function initializeApp(appInit: AppInitializerService) {
  return (): Promise<boolean> => {
    return appInit.init();
  };
}
